import React from 'react';
import Typography from '@material-ui/core/Typography';
import PageSegment from '../../../components/PageSegment';
import Paper from '@material-ui/core/Paper';
import { Router, Match, Link } from '@reach/router';
import { withStyles } from '@material-ui/core/styles';
import Button from '../../../components/Button';
import TargetResultGauge from '../../../components/TargetResultGauge';
import DashboardContext from '../../../contexts/DashboardContext';
import get from 'lodash/get';
import gql from 'graphql-tag';
import UserContext from '../../../contexts/UserContext';
import { useQuery, useApolloClient } from 'react-apollo-hooks';
import { Map } from 'immutable';
import Divider from '@material-ui/core/Divider';
import PlanResults from './PlanResults';
import format from 'date-fns/format';
import startOfWeek from 'date-fns/startOfWeek';
import endOfWeek from 'date-fns/endOfWeek';
import subDays from 'date-fns/subDays';
import { LIST_PERIOD_BY_DATE_RANGE } from '../../../common/graphql/ListPeriodByDateRange';
import PerformanceTab from '../MyTeamPage/PerformanceTab';
import Message from '../../../components/Message';

const styles = theme => ({
  root: {
    // fontWeight: 'bold',
  },
  segment: {
    marginTop: 20,
  },
  segmentContent: {
    padding: 20,
  },
  tabButton: {
    padding: 15,
    width: 180,
    borderRadius: 30,
    margin: '0 15px',
  },
  weekNameSmall: {
    position: 'absolute',
    fontSize: 'small',
    bottom: 0,
    opacity: 0.8,
  },
  headerControls: {
    marginBottom: 15,
    textAlign: 'right',
  },
});

export async function fetchLastWeekPeriod(client) {
  const dateFormat = 'yyyy-MM-dd';
  const dateWeekAgo = subDays(new Date(), 7);
  const weekStart = format(startOfWeek(dateWeekAgo, { weekStartsOn: 1 }), dateFormat);
  const weekEnd = format(endOfWeek(dateWeekAgo, { weekStartsOn: 1 }), dateFormat);
  console.log('last week START: ', weekStart);
  console.log('last week END: ', weekEnd);

  const ret = await client.query({
    query: LIST_PERIOD_BY_DATE_RANGE.query,
    variables: {
      from: weekStart,
      to: weekEnd,
    },
    fetchPolicy: 'network-only',
  });
  console.log('>>MyResultsPage/index::', 'ret', ret); //TRACE
  const period = get(ret, 'data.listPeriods.items.0');
  // console.log('>>MyResultsPage/index::', 'periodId', periodId); //TRACE
  return period;
}

export async function fetchLastWeekPeriodId(client) {
  const period = await fetchLastWeekPeriod(client);
  return get(period, 'id');
}

function WeekSwitcher() {
  return (
    <Match path="/hot/:item">
      {props => (props.match ? <div>Hot {props.match.item}</div> : <div>Uncool</div>)}
    </Match>
  );
}

export default withStyles(styles)(function(props) {
  const { classes } = props;

  const { state: dashboardState, service, previousPeriod, ...rest } = React.useContext(
    DashboardContext,
  );
  const { currentUser } = React.useContext(UserContext);
  const [state, setState] = React.useState(Map({ periodId: null, selectedBtn: 0 }));

  const member = get(currentUser, 'memberInfo', {});
  const { id: memberId } = member;
  const period = get(dashboardState, 'context.currentPeriod', {});
  React.useEffect(() => {
    setState(oldState => oldState.merge({ periodId: period.id }));
  }, [period]);

  const periodId = state.get('periodId');

  const onLastWeekClick = React.useCallback(async () => {
    const periodId = previousPeriod.id;
    setState(oldState => oldState.merge({ periodId, selectedBtn: 1 }));
  }, [state]);

  const onThisWeekClick = React.useCallback(() => {
    setState(oldState => oldState.merge({ periodId: period.id, selectedBtn: 0 }));
  }, [period]);
  const lastPeriodName = React.useMemo(() => {
    if (previousPeriod) {
      console.log('kraken wtf');
      return previousPeriod.name;
    } else {
      return '';
    }
  }, [previousPeriod]);
  return (
    <div className={classes.root}>
      <PageSegment compact title="My Results">
        <div className={classes.headerControls}>
          <Match path="/my-results/performance">
            {props =>
              props.match && (
                <Link to="/my-results">
                  <Button>Show Results</Button>
                </Link>
              )
            }
          </Match>
          <Match path="/my-results">
            {props =>
              props.match && (
                <Link to="/my-results/performance">
                  <Button>Show Performance</Button>
                </Link>
              )
            }
          </Match>
        </div>
        <center>
          <Match path="/my-results">
            {props =>
              props.match ? (
                <>
                  <Button
                    size="large"
                    color={state.get('selectedBtn') === 0 ? 'secondary' : undefined}
                    className={classes.tabButton}
                    onClick={onThisWeekClick}
                  >
                    This Week
                    <div className={classes.weekNameSmall}>{period.name}</div>
                  </Button>
                  <Button
                    size="large"
                    // disabled={!lastPeriodName}
                    color={state.get('selectedBtn') === 1 ? 'secondary' : undefined}
                    className={classes.tabButton}
                    onClick={onLastWeekClick}
                  >
                    Last Week
                    <div className={classes.weekNameSmall}>{lastPeriodName}</div>
                  </Button>
                </>
              ) : null
            }
          </Match>
        </center>
        <Match path="/my-results/performance">
          {props => props.match && <Divider style={{ margin: 10 }} />}
        </Match>
        <Router primary={false}>
          <PerformanceTab path="/performance" member={member} />
          <PlanResults periodId={periodId} memberId={memberId} default />
        </Router>
      </PageSegment>
    </div>
  );
});
